<template>
  <div v-if="visible" class="message-cmp">
    <img src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/gouxuan.png" alt="" srcset="">
    <span>{{message}}</span>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String
    },
    duration: {
      type: Number,
      default: 1500
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    show() {
      this.visible = true
      setTimeout(() => {
        this.visible = false
      }, this.duration)
    }
  }
}
</script>

<style lang="scss" scoped>
.message-cmp{
  width: 240px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 240px;
  background: rgba(0, 0, 0, 0.45);
  border-radius: 10px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  box-sizing: border-box;
  padding: 28px 35px 35px 35px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-120px);
  z-index: 1000;
  img{
    width: 46px;
    height: 46px;
    margin-bottom: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Message.vue